export default "__VITE_ASSET__Bhzg2VIu__"